export const atomicVersion = process.env.VERSION || 'Test version';
export {version as headlessVersion} from '@coveo/headless/package.json';
